import { from } from 'rxjs';
import type { Observable } from 'rxjs';
import { getSellerProviders as getSellerProvidersBase } from '@shipstation/client-common/api/ltl.api';

import type { SellerFreightProvider } from './freight-types';

export const getSellerProviders = (): Observable<SellerFreightProvider[]> => from(getSellerProvidersBase());
